<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_7620_33616)">
      <path d="M4.05722 7.28769L7.76953 11L11.5195 7.25M7.76953 11L7.81978 1.05025" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M0.769531 15H14.7695" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_7620_33616">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconDownload'
}
</script>
